import React from 'react';
import { useSelector } from 'react-redux';
import InPageNavBar from 'components/InPageNavBar';
import { getPropertyFiltersModalVisible } from 'store/ui/uiSelectors';

const JumpToMenu = ({ ...rest }) => {
  const propertyFiltersModalVisible = useSelector(getPropertyFiltersModalVisible);

  return <InPageNavBar {...rest} sticky={!propertyFiltersModalVisible} />;
};

export default JumpToMenu;
